import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=0407518c&"
import script from "./CardWidget.vue?vue&type=script&lang=js&"
export * from "./CardWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0407518c')) {
      api.createRecord('0407518c', component.options)
    } else {
      api.reload('0407518c', component.options)
    }
    module.hot.accept("./CardWidget.vue?vue&type=template&id=0407518c&", function () {
      api.rerender('0407518c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/card-widget/CardWidget.vue"
export default component.exports